/* eslint-disable max-len */
import { useDispatch, useSelector } from "react-redux";

import { IRootState } from "../../../state";
// eslint-disable-next-line no-unused-vars
import React from "react";
import { IWellnessPurchaseState, wellnessPlanPurchaseActions } from "../../../state/wellness-purchase-data";
import { FlattenedPlanData } from "../../useWellnessPlans";

const useWellnessPurchaseData = () => {
  const dispatch = useDispatch();
  const { wellnessPurchaseData } = useSelector((state: IRootState) => state.wellnessPurchaseData as IWellnessPurchaseState);

  const setWellnessPurchaseData = (payload: FlattenedPlanData | null) => {
    dispatch(wellnessPlanPurchaseActions.setWellnessPurchaseData(payload));
  };


  return {
    setWellnessPurchaseData,
    wellnessPurchaseData,
  };
};

export default useWellnessPurchaseData;
